import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 合同类型
 */
class ContractType extends UltMeta {
    PURCHASE = new Meta(1, "采购合同");
    SALES = new Meta(2, "销售合同");
    WAREHOUSING = new Meta(11, "仓储合同");
    PAYMENT_COMMISSION = new Meta(3, "支付委托书");
    LOAN_APPLICATION = new Meta(4, "提款申请书");
    LOAN_AGREEMENT = new Meta(5, "借款合同");
    LOAN_GUARANTEE = new Meta(6, "借款凭证");
    GUARANTEE_AGREEMENT = new Meta(7, "担保合同");
    // WAREHOUSING = new Meta(11, "仓储合同");
    INTEGRATED_SERVICE = new Meta(8, "综合服务协议");
    SUPPLEMENTAL_AGREEMENT = new Meta(9, "补充协议");
    OTHER = new Meta(10, "其他");
}

export const CONTRACT_TYPE = new ContractType();
/**
 * 签署方式
 */
class SignMode extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}
export const SIGN_MODE = new SignMode();
